import React from 'react'
import Page from '../components/Page'
import Typography from '../components/Typography'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Form, FormFeedback, FormGroup, FormText, Input, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup } from 'reactstrap'
import { MdEdit, MdFormatListBulleted, MdFlag, MdLanguage, MdHome, MdAdd, MdCameraAlt, MdDone, MdClear, MdFilterList, MdCreate, MdDelete } from 'react-icons/md'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import axios from '../utils/posAxios'
import PosMembershipTierForm from '../components/PosMembershipTierForm'
import PosMembershipPromoForm from '../components/PosMembershipPromoForm'
import PosScheduleModForm from '../components/PosScheduleModForm'
import PosScheduleSlotDayForm from '../components/PosScheduleSlotDayForm'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import moment from 'moment-timezone'

const point_column = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Issue Date',
    field: 'issued_dt',
    sort: 'asc',
  },
  {
    label: 'Expiry Date',
    field: 'expiry_dt',
    sort: 'asc',
  },
  {
    label: 'Awarded Points',
    field: 'award_points',
    sort: 'asc',
  },
  {
    label: 'Awarded Tier',
    field: 'tier_name',
    sort: 'asc',
  },
]

const redeem_column = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Use Date',
    field: 'used_dt',
    sort: 'asc',
  },
  {
    label: 'Used Point',
    field: 'used_points',
    sort: 'asc',
  },
  {
    label: 'Used Tier',
    field: 'tier_name',
    sort: 'asc',
  },
  {
    label: 'Discount Value',
    field: 'discount_value',
    sort: 'asc',
  },
  {
    label: 'Store Name',
    field: 'name',
    sort: 'asc',
  },
]

const spend_column = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Record Date',
    field: 'record_dt',
    sort: 'asc',
  },
  {
    label: 'Total Purchase',
    field: 'total_purchase',
    sort: 'asc',
  },
  {
    label: 'Store Name',
    field: 'name',
    sort: 'asc',
  },
]

class PosMembershipMemberDetailPage extends React.Component {
  access = StorageService.getSession('user_access')
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isGlobal: true,
      // isStore: this.props.history.location.state.isStore,
      //role: this.props.history.location.state.store_id ? this.access.store.find(x => x.store_id == this.props.history.location.state.store_id).role : '',
      isEdit: false,
      redirect: false,
      //   selectedId: '',
      //   selectedData: '',
      //   selectedType: '',
      name: '',
      email: '',
      member_type: '',
      accumulation: '',
      accumulation_type: '',
      current_points: '',
      tier: '',
      spend_record: [],
      redeem_record: [],
      points_record: [],
      membership_id: this.props.match.params.id,
      member_id: this.props.match.params.member_id,
      awardModal: false,
      storeList: [],
      tierList: [],
      tier_id: '',
      store_id: '',
      award_points: '',
      expiry_duration: '',
    }
  }

  componentDidMount() {
    this.getMembershipMemberDetail()
    this.getStoreList()
    this.getTierList()
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  toggleAward =
    (action, id, type = null) =>
    () => {
      return this.setState({
        awardModal: !this.state.awardModal,
        selectedId: id,
        selectedType: type,
      })
    }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      awardModal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getMembershipMemberDetail()
    }
  }

  getMembershipMemberDetail = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const membership_id = this.props.match.params.id
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      id: this.state.membership_id,
      customer_id: this.state.member_id,
    }

    axios
      .post(url + ':3001/v1/membership/customerdetail/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        // for (let i of result.data.members) {
        //   i.Action = (
        //     <div className="ps-action-button">
        //       <Button className="theme-button theme-button-secondary" onClick={this.togglecustomerdetail(i.customer_id)}>
        //         Detail
        //       </Button>
        //       {/* <Button className="theme-button theme-button-primary-light" onClick={this.togglePromoConfirmModal(i.tier_name, i.applied_tier, i.id)}>
        //         Remove
        //       </Button> */}
        //     </div>
        //   )
        // }

        for (let i of result.data.redeem_record) {
          i.used_dt = moment(i.used_dt).tz('Asia/Singapore').format('YYYY-MM-DD HH:mm:ss')
        }

        for (let i of result.data.spend_record) {
          i.record_dt = moment(i.record_dt).tz('Asia/Singapore').format('YYYY-MM-DD HH:mm:ss')
        }

        for (let i of result.data.points_record) {
          i.issued_dt = moment(i.issued_dt).tz('Asia/Singapore').format('YYYY-MM-DD HH:mm:ss')
          i.expiry_dt = moment(i.expiry_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
        }

        this.setState({
          name: result.data.name,
          email: result.data.email,
          member_type: result.data.member_type,
          accumulation_type: result.data.accumulation_type,
          accumulation: result.data.accumulation,
          points: result.data.points,
          tier: result.data.tier,
          spend_record: result.data.spend_record,
          redeem_record: result.data.redeem_record,
          points_record: result.data.points_record,
        })
      })
      .catch(error => {
        alert(error)
      })
  }

  getStoreList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const access = StorageService.getSession('user_access')
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            storeList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getTierList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const access = StorageService.getSession('user_access')
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      membership_id: this.props.match.params.id,
    }

    axios
      .post(url + ':3001/v1/membership/tier', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            tierList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  addAwardRecord = event => {
    event.preventDefault()

    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const comp = StorageService.getSession('selected_org')

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
      tier_id: this.state.tier_id,
      customer_id: this.props.match.params.member_id,
      id: this.state.membership_id,
      points: this.state.award_points,
      expiry_duration: this.state.expiry_duration,
      added_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/customerdetail/points/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.closeModal(<MdDone />, 'Award Record added successfully.', 'success', false)
        this.getMembershipMemberDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    const points_data = {
      columns: point_column,
      rows: this.state.points_record,
    }

    const redeem_data = {
      columns: redeem_column,
      rows: this.state.redeem_record,
    }

    const spend_data = {
      columns: spend_column,
      rows: this.state.spend_record,
    }

    return (
      <Page
        className="PosMembershipDetailPage"
        title="Member"
        breadcrumbs={[
          { name: 'Store', active: false, path: '/posstore' },
          { name: 'Member', active: false, path: `/posstore/membership/member/${this.state.membership_id}` },
          { name: 'Member Detail', active: true, path: '' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">Member Detail</CardHeader>
              <CardBody>
                <Row form>
                  <Col lg={3}>
                    <Label>Name</Label>
                    <p>{this.state.name}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Email</Label>
                    <p>{this.state.email}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Membership Type</Label>
                    <p>{this.state.member_type}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Accumulation Type</Label>
                    <p>{this.state.accumulation_type}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Accumulation</Label>
                    <p>{this.state.accumulation}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Current Points</Label>
                    <p>{this.state.points}</p>
                  </Col>
                  <Col lg={3}>
                    <Label>Tier</Label>
                    <p>{this.state.tier}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Award Record</Typography>
                    </div>
                  </Col>
                  <Col>
                    <div className="text-right mb-4">
                      <Button className="theme-button theme-button-primary" onClick={this.toggleAward('ADD', null)}>
                        Add
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <MDBDataTableV5 className="ps-order-table th-5" data={points_data} displayEntries={false} searching={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive={true} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Redeem Record</Typography>
                    </div>
                  </Col>
                  <Col>
                    {/* <div className="text-right mb-4">
                      <Button className="theme-button theme-button-primary" onClick={this.togglestore('ADD', null)}>
                        Add
                      </Button>
                    </div> */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <MDBDataTableV5 className="ps-order-table th-6" data={redeem_data} displayEntries={false} searching={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive={true} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <Row>
                  <Col>
                    <div className="text-left">
                      <Typography className="h5">Spend Record</Typography>
                    </div>
                  </Col>
                  <Col>
                    {/* <div className="text-right mb-4">
                      <Button className="theme-button theme-button-primary" onClick={this.togglestore('ADD', null)}>
                        Add
                      </Button>
                    </div> */}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <MDBDataTableV5 className="ps-order-table th-4" data={spend_data} displayEntries={false} searching={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive={true} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={this.state.awardModal} toggle={this.toggleAward()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form className="AuthForm" onSubmit={this.addAwardRecord}>
            <ModalHeader toggle={this.toggleAward()}>Add Award Record</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Store</Label>
                    <Input type="select" name="store_id" value={this.state.store_id} onChange={this.changeHandler} required>
                      <option value=""></option>
                      {this.state.storeList.length > 0 &&
                        this.state.storeList.map(item => {
                          return (
                            <option key={item.store_id} value={item.store_id}>
                              {item.name}
                            </option>
                          )
                        })}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label>Tier</Label>
                    <Input type="select" name="tier_id" value={this.state.tier_id} onChange={this.changeHandler} required>
                      <option value=""></option>
                      {this.state.tierList.length > 0 &&
                        this.state.tierList.map(item => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.tier_name}
                            </option>
                          )
                        })}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label>Points</Label>
                    <Input type="number" name="award_points" value={this.state.award_points} onChange={this.changeHandler} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Expiry Duration</Label>
                    <Input type="number" name="expiry_duration" value={this.state.expiry_duration} onChange={this.changeHandler} required />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        {/* <Modal isOpen={this.state.storeModal} toggle={this.togglestore()} className={this.props.className} centered>
          <Form className="AuthForm" onSubmit={this.addMembershipStore}>
            <ModalHeader toggle={this.togglestore()}>Membership Store</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Store</Label>
                    <Input type="select" name="selected_store_id" value={this.state.selected_store_id} onChange={this.changeHandler} required>
                      <option value=""></option>
                      {this.state.storeList.length > 0 &&
                        this.state.storeList.map(item => {
                          return (
                            <option key={item.store_id} value={item.store_id}>
                              {item.name}
                            </option>
                          )
                        })}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          </Form>
        </Modal> */}
      </Page>
    )
  }
}

export default PosMembershipMemberDetailPage
